module.exports = __webpack_public_path__ + "static/media/r293.dac01a42.jpg";